/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Container, ContainerProps } from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader';

type Props = {
  name: string;
  parentName: string;
  children: JSX.Element | JSX.Element[];
  containerProps?: ContainerProps;
};

export default ({ name, parentName = 'LMS', children, containerProps }: Props) => {
  return (
    <React.Fragment>
      <SimpleHeader name={name} parentName={parentName} />
      <Container fluid {...containerProps} className={`mt--6 ${containerProps?.className || ''}`}>
        {children}
      </Container>
    </React.Fragment>
  );
};
